import React, { useState } from 'react';
import {
  Link as LinkMenuType,
  MegamenuLink,
} from '../../../models/domain/interfaces';

import {
  BottomNavigationStyled,
  BottomNavigationActionStyled,
  BottomNavbarWrapper,
  ImageWrapper,
} from './BottomNavbar.style';
import { useRouter } from 'next/router';
import { hexToRgb, rgbDataURL } from 'corporate-utils';
import { getStrapiMedia } from '../../../utils/media';
import SvgInline from '../../svg-inline/SvgInline';
import { ReservedArea } from '../../../models/auto-generated-strapi-types/types/components/ReservedArea';
import { LocalizedPaths } from '../../../models/domain/type';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import ImageWithFallback from '../../image-with-fallback/ImageWithFallback';

interface HeaderProps {
  logo?: any;
  mainLinks?: LinkMenuType[];
  megamenuLinks?: MegamenuLink[];
  locale?: string;
  translations?: { [key: string]: any };
  localizedPaths?: LocalizedPaths;
  reservedArea?: ReservedArea;
  onMouseOver?: (
    idDwh: string,
    indexSection: number,
    cover: any,
    recommendedProduct: any
  ) => void;
  onMouseClick?: () => void;
  mainLinksFontSize?: number;
  mainLinksMobileFontSize?: number;
  mainLinksFontWeight?: number;
  mainLinksMobileFontWeight?: number;
  megamenuLinksFontSize?: number;
  megamenuLinksMobileFontSize?: number;
  megamenuLinksFontWeight?: number;
  megamenuLinksMobileFontWeight?: number;
  isPrerenderRequest: boolean;
}

const BottomNavbar: React.FC<any> = ({
  megamenuLinks,
  locale,
  megamenuLinksFontSize,
  megamenuLinksMobileFontSize,
  megamenuLinksFontWeight,
  megamenuLinksMobileFontWeight,
  isPrerenderRequest,
}: HeaderProps) => {
  const [value, setValue] = useState('/home');

  const router = useRouter();

  return (
    <BottomNavbarWrapper>
      <BottomNavigationStyled
        value={value}
        onChange={(event, newValue): void => {
          setValue(newValue);
        }}
        showLabels
      >
        {megamenuLinks
          ?.filter((link: MegamenuLink) => {
            return !link.hideOnMobile;
          })
          .map((link: MegamenuLink, index: number) => {
            return (
              <BottomNavigationActionStyled
                key={`linkaction_bottombar_${index}`}
                value={link.url}
                label={link.shortText || link.text || ''}
                icon={
                  link?.iconAsset?.data?.attributes?.ext !== '.svg' ? (
                    <ImageWrapper>
                      <ImageWithFallback
                        layout="fill"
                        objectFit="contain"
                        objectPosition="left"
                        placeholder="blur"
                        blurDataURL={rgbDataURL(
                          hexToRgb('ffffff')?.[0],
                          hexToRgb('ffffff')?.[1],
                          hexToRgb('ffffff')?.[2]
                        )}
                        src={getStrapiMedia(
                          link?.iconAsset?.data?.attributes?.url || ''
                        )}
                        alt={link?.iconAsset?.data?.attributes?.alternativeText}
                        fallbackSrc={DEFAULT_IMAGE}
                        isPrerenderRequest={isPrerenderRequest}
                      />
                    </ImageWrapper>
                  ) : (
                    <ImageWrapper>
                      <SvgInline
                        url={link?.iconAsset?.data?.attributes?.url}
                      ></SvgInline>
                    </ImageWrapper>
                  )
                }
                onClick={() => {
                  router.push(
                    {
                      pathname: link.url,
                      query: null,
                    },
                    {
                      pathname: link.url,
                      query: null,
                    },
                    { locale: locale }
                  );
                }}
                fontWeight={megamenuLinksFontWeight}
                mobileFontWeight={megamenuLinksMobileFontWeight}
                fontSize={megamenuLinksFontSize}
                mobileFontSize={megamenuLinksMobileFontSize}
              />
            );
          })}
      </BottomNavigationStyled>
    </BottomNavbarWrapper>
  );
};

export default BottomNavbar;
